import { ApiAction } from 'redux-upgrader'

export const TOGGLE_WEBPUSH_SETTINGS_POPUP = 'TOGGLE_WEBPUSH_SETTINGS_POPUP'
export const GET_PUSH_SETTINGS = new ApiAction('GET_PUSH_SETTINGS')
export const SET_PUSH_SETTINGS = new ApiAction('SET_PUSH_SETTINGS')
